import React from 'react';
import { Route, Switch, Redirect } from 'react-router';

import { SettingsProfil } from './profile';
import { SettingsNotifications } from './notifications';
import { SettingsFacturation } from './facturation';
import { SettingsPaiement } from './paiement';
import { SettingsSecurite } from './securite';

import { Header } from './_common/header';

export const Settings = () => {
    return (
        <article className="view-calc pt-6 pt-gd-sm mb-auto pb-sm">
            <h1 className="sr-only visually-hidden">Settings</h1>
            <Header />
            <Switch>
                <Route exact path="/anticipa/settings" component={SettingsProfil} />
                <Route path="/anticipa/settings/securite" component={SettingsSecurite} />
                <Route path="/anticipa/settings/notifications" component={SettingsNotifications} />
                <Route path="/anticipa/settings/paiement" component={SettingsPaiement} />
                <Route path="/anticipa/settings/facturation" component={SettingsFacturation} />

                <Route render={() => {
                    return <Redirect exact to="/anticipa/settings" />
                }} />
            </Switch>
        </article>
    )
};